<template>
  <div class="check-list-summary" v-if="checkList">
    <table class="table is-narrow is-hoverable summary">
      <tbody>
        <tr v-for="(check, index) in checkList.checks" :key="index" @click="$emit('check-click', index)">
          <th :colspan="check.type === 'text' ? 2 : 1">
            {{ check.name }}
            <div v-if="check.type === 'text' && check.value.length" class="text nl">{{ check.value }}</div>
            <div v-if="check.comment.length" class="comment nl"><b>comment:</b> {{ check.comment }}</div>
          </th>
          <td v-if="check.type !== 'text'" class="pointer value text-right">
            <template class="value" v-if="check.type === 'checkbox'">
              <font-awesome-icon icon="check" class="has-text-success" size="2x" v-if="check.value === 'yes'" />
              <font-awesome-icon icon="times" class="has-text-danger" size="2x" v-else-if="check.value === 'no'" />
              <font-awesome-icon icon="question" class="has-text-grey-light" size="2x" v-else-if="!check.value.length" />
              <span class="has-text-grey-light bold" v-if="check.value === 'na'">NA</span>
            </template>
            <template class="value" v-else>{{ check.value }}</template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CheckListSummary',
  props: ['checkList']
}
</script>

<style>
  .check-list-summary table.summary {
    border: solid 1pX #EEE;
  }

  .check-list-summary .text,

  .check-list-summary .comment {
    font-style: italic;
  }

  .check-list-summary table td.value {
    border-left: none;
  }
</style>
